module.exports = __webpack_public_path__ + "img/back.349f5386.svg";